"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PeriodSelector = PeriodSelector;
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _ChevronRight2 = _interopRequireDefault(require("@mui/icons-material/ChevronRight"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _ChevronLeft2 = _interopRequireDefault(require("@mui/icons-material/ChevronLeft"));
var _moment = _interopRequireDefault(require("moment"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const now = (0, _moment.default)();
function PeriodSelector(_ref) {
  let {
    type,
    period,
    dates,
    nextPeriodTooltip,
    onPeriodSelected,
    onDateIndexSelected,
    prevPeriodTooltip,
    selectedDateIndex
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "bottom",
    title: prevPeriodTooltip
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(StyledPrevButton, {
    disabled: !period && (!dates || selectedDateIndex === 0 || selectedDateIndex === -1),
    onClick: () => period ? onPeriodSelected?.(period.getPrevPeriod()) : selectedDateIndex !== undefined && onDateIndexSelected?.(selectedDateIndex - 1),
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_ChevronLeft2.default, null)))), period ? /*#__PURE__*/_react.default.createElement(StyledTitle, {
    align: "center",
    className: type
  }, period.from.format(type === 'year' ? 'YYYY' : 'MMMM YYYY')) : selectedDateIndex !== undefined && dates?.[selectedDateIndex] ? /*#__PURE__*/_react.default.createElement(StyledTitle, {
    align: "center",
    className: type
  }, dates[selectedDateIndex].format(type === 'year' ? 'YYYY' : 'MMMM YYYY')) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  }), /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "bottom",
    title: nextPeriodTooltip
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(StyledNextButton, {
    disabled: period ? period.to.isAfter(now) : !dates || selectedDateIndex === dates.length - 1,
    onClick: () => period ? onPeriodSelected?.(period.getNextPeriod()) : selectedDateIndex !== undefined && onDateIndexSelected?.(selectedDateIndex + 1),
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_ChevronRight2.default, null)))));
}
const StyledPrevButton = (0, _styledComponents.default)(_IconButton2.default)`
  && {
    margin-right: 8px;
  }
`;
const StyledTitle = (0, _styledComponents.default)(_Typography2.default)`
  width: 120px;

  &.year {
    width: 60px;
  }
`;
const StyledNextButton = (0, _styledComponents.default)(_IconButton2.default)`
  && {
    margin-left: 8px;
  }
`;